import { render } from "./commodityManage.vue?vue&type=template&id=7e59cd46&ts=true"
import script from "./commodityManage.vue?vue&type=script&lang=ts"
export * from "./commodityManage.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__